import React, { useEffect, useState } from "react";
import { Grid, makeStyles, Typography, Button } from "@material-ui/core";
import styles from "../../../../styles/global-styles";
import InputMask from "react-input-mask";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";
import { actions } from "../../../../redux/actions/alert";
import { CashCardService } from "../../../../services/cashCard.service";
import { CardCatalogueService } from "../../../../services/cardCatalogue.service";

const usetSyles = makeStyles((theme) => ({
  form: {
    width: "auto", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  label: {
    marginBottom: "1.5vh",
  },
  formControl: styles.globalFormControl,
  inputBoxSpace: styles.inputBoxSpace,
  backgroundIcon: styles.backgroundIcon,
  box: {
    marginTop: "30px",
  },
}));

const AddCashCardToInventory = ({
  addAlert,
  detailAlert,
  detailProduct,
  bulkCashCardCreated,
}) => {
  const classes = usetSyles();

  const [productsQuantity, setProductsQuantity] = useState(null);
  const [cardInfo, setCardInfo] = useState({});
  const [cashCardBulk, setCashCardBulkBulk] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const {
          data: { name, amount },
        } = await CardCatalogueService.getCardCatalogueById(
          detailProduct.cardCatalogueId
        );
        setCardInfo({ ...cardInfo, name, amount });
      } catch (error) {
        console.log("error getCardCatalogueById", error);
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
      }
    })();
  }, []);

  useEffect(() => {
    if (cashCardBulk.length) {
      (async () => {
        try {
          const { status, data } = await CashCardService.createCashCardBulk(
            cashCardBulk
          );
          // console.log("status", status);
          if (status === 201)
            bulkCashCardCreated(
              true,
              "Stock dado de alta exitosamente",
              "stock",
              data
            );
        } catch (error) {
          console.log("catch error", error.msgs);
          addAlert({ showAlert: true });
          detailAlert({ severity: "error", message: error.msgs, time: 2000 });
        }
      })();
    }
  }, [cashCardBulk]);

  const submitCashCardQuantity = async () => {
    if (productsQuantity === undefined) {
      return;
    }
    const copyCashCardBulk = [...cashCardBulk];
    const parseQuantity = parseInt(productsQuantity);
    const productQuantArray = [];
    for (let index = 0; index < parseQuantity; index++) {
      productQuantArray.push("");
    }
    productQuantArray.forEach((_, index) => {
      /** Create product in Almacen */
      detailProduct.siteId = 1;
      detailProduct.inDistribution = 0;
      copyCashCardBulk[index] = { ...detailProduct };
    });
    // console.log("copyBulkMoviles BEFORE", copyCashCardBulk);
    setCashCardBulkBulk(copyCashCardBulk);
  };

  return (
    <React.Fragment>
      <ValidatorForm
        onKeyPress={(event) => {
          if (event.which === 13 /* Enter */) {
            event.preventDefault();
          }
        }}
        noValidate
        className={classes.form}
        method="POST"
        onSubmit={submitCashCardQuantity}
      >
        <Grid
          container
          direction="row"
          justify="space-around"
          alignItems="center"
        >
          {detailProduct && Object.values(cardInfo).length > 0 && (
            <Grid item xs={12}>
              <Typography
                variant="h4"
                style={{ fontWeight: "bold" }}
                component={"div"}
              >
                Tarjeta de saldo {cardInfo.name} ${cardInfo.amount}
              </Typography>
            </Grid>
          )}

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            style={{ marginTop: "30px" }}
          >
            <Typography
              variant="body2"
              component={"div"}
              className={classes.label}
            >
              Existencia
            </Typography>
            <InputMask
              mask="99"
              maskChar=""
              value={productsQuantity || ""}
              onChange={(e) => {
                setProductsQuantity(e.target.value);
              }}
            >
              {() => (
                <TextValidator
                  name="model"
                  variant="outlined"
                  validators={["required"]}
                  errorMessages={["Es necesario agregar el número de tarjetas"]}
                ></TextValidator>
              )}
            </InputMask>
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: "20px" }}
              type="submit"
            >
              Agregar
            </Button>
          </Grid>
        </Grid>
      </ValidatorForm>
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(AddCashCardToInventory);
